import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import { useConfirm } from 'material-ui-confirm';
import DashboardLayout from '../../examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import SuiBox from '../../components/SuiBox';
import SuiTypography from '../../components/SuiTypography';
import SuiButton from '../../components/SuiButton';
import GlobalLoading from '../../components/GlobalLoading';
import BannerModal from './BannerModal';
import { fetchBanners, requestRemovingBanner } from '../../redux/actions/bannersActionCreators';

function BannerImage({ banner }) {
  const image =
    banner.attributes.image && banner.attributes.image.data
      ? banner.attributes.image.data.attributes
      : null;
  if (!image) return null;
  return (
    <img
      src={`${process.env.REACT_APP_API_URL}${image.url}`}
      alt=""
      style={{ width: 90, height: 50, objectFit: 'cover', borderRadius: 6 }}
    />
  );
}

function BannerRow({ banner, onEdit, onDelete }) {
  return (
    <TableRow>
      <TableCell align="center">
        <BannerImage banner={banner} />
      </TableCell>
      <TableCell align="center">{banner.attributes.productLink}</TableCell>
      <TableCell align="center">{banner.attributes.order}</TableCell>
      <TableCell align="center">{banner.attributes.isActive ? 'Oui' : 'Non'}</TableCell>
      <TableCell align="center">
        <Icon sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => onEdit(banner)}>
          edit
        </Icon>
        &nbsp;&nbsp;
        <Icon sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => onDelete(banner)}>
          delete
        </Icon>
      </TableCell>
    </TableRow>
  );
}

export default function Banners() {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const banners = useSelector((state) => state.banners.list);

  const [openModal, setOpenModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const handleAdd = () => {
    setSelected(null);
    setIsUpdating(false);
    setOpenModal(true);
  };

  const handleEdit = (banner) => {
    setSelected(banner);
    setIsUpdating(true);
    setOpenModal(true);
  };

  const handleDelete = (banner) => {
    confirm({ description: 'Voulez vous supprimer définitivement cette bannière ?' })
      .then(() => {
        dispatch(requestRemovingBanner(banner.id));
      })
      .catch(() => console.log('Suppression annulée'));
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const initialValues = isUpdating
    ? {
        productLink: selected.attributes.productLink || '',
        order: selected.attributes.order || 0,
        isActive: selected.attributes.isActive,
      }
    : { productLink: '', order: (banners && banners.length) || 0, isActive: true };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SuiBox mb={3} px={3} display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <SuiTypography variant="h6">Bannières</SuiTypography>
        <SuiButton variant="gradient" color="dark" onClick={handleAdd}>
          <Icon sx={{ fontWeight: 'bold' }}>add</Icon>
          &nbsp;Ajouter une bannière
        </SuiButton>
      </SuiBox>

      <Card>
        <SuiBox>
          <GlobalLoading />
          <TableContainer style={{ overflow: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Image</TableCell>
                  <TableCell align="center">Lien produit</TableCell>
                  <TableCell align="center">Ordre</TableCell>
                  <TableCell align="center">Active</TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {banners &&
                  banners.map((banner) => (
                    <BannerRow key={banner.id} banner={banner} onEdit={handleEdit} onDelete={handleDelete} />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SuiBox>
      </Card>

      <BannerModal
        open={openModal}
        handleClose={handleClose}
        isUpdating={isUpdating}
        id={selected ? selected.id : undefined}
        previewUrl={
          selected && selected.attributes.image && selected.attributes.image.data
            ? `${process.env.REACT_APP_API_URL}${selected.attributes.image.data.attributes.url}`
            : null
        }
        initialValues={initialValues}
      />
    </DashboardLayout>
  );
}
